
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.024 0a.75.75 0 01.749.751l-.014 10.5a.75.75 0 01-1.5-.002l.014-10.5A.75.75 0 016.023 0z","fill":"#333"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 6a.75.75 0 01.75-.75h10.5a.75.75 0 010 1.5H.75A.75.75 0 010 6z","fill":"#333"}})])
          )
        }
      }
    